import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import InputMask from 'react-input-mask'
import { useEnergiaAquecimentoContext } from '../../../context/energiaAquecimentoContext'
import { onlyNumberWithDecimal } from '../../../components/functions'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {

    const energia_id = props.energia_id
    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id

    const { setAtualizacaoGestao } = useTabelaGestao()
    const { energiaAquecimento_id, setEnergiaAquecimento_id } = useEnergiaAquecimentoContext()


    const [tipo, setTipo] = useState('')
    const [tag, setTag] = useState('')
    const [marca, setMarca] = useState('')
    const [modelo, setModelo] = useState('')
    const [anoFabricacao, setAnoFabricacao] = useState('')
    const [quantidade, setQuantidade] = useState('')

    const [banhoHigienizacao, setBanhoHigienizacao] = useState()
    const [limpezaEsterelizacao, setLimpezaEsterelizacao] = useState()
    const [coccao, setCoccao] = useState()
    const [aquecimento, setAquecimento] = useState()

    const [rotinaManutencao, setRotinaManutencao] = useState('')
    const [entradaOperacao, setEntradaOperacao] = useState('')
    const [saidaOperacao, setSaidaOperacao] = useState('')

    //const [ambiente, setAmbiente] = useState()

    const [fonteEnergetica, setFonteEnergetica] = useState('')
    const [volumeReservatorio, setVolumeReservatorio] = useState('')
    const [vazaoMediaAgua, setVazaoMediaAgua] = useState('')
    const [tempoOperacaoDiario, setTempoOperacaoDiario] = useState('')
    const [diasOperacaoAnual, setDiasOperacaoAnual] = useState('')
    const [tempEntradaAgua, setTempEntradaAgua] = useState('')
    const [tempSaidaAgua, setTempSaidaAgua] = useState('')
    const [tempProgramada, setTempProgramada] = useState('')


    const [fluidoRefrigerante, setFluidoRefrigerante] = useState('')
    const [capacTermicaAquecimento, setCapacTermicaAquecimento] = useState('')
    const [copAquecimento, setCopAquecimento] = useState('')
    const [tempEntradaAguaQuenteBomba, setTempEntradaAguaQuenteBomba] = useState('')
    const [tempSaidaAguaQuenteBomba, setTempSaidaAguaQuenteBomba] = useState('')

    const [capacTermicaResfriamento, setCapacTermicaResfriamento] = useState('')
    const [copResfriamento, setCopResfriamento] = useState('')

    const [tempEntradaAguaFriaBomba, setTempEntradaAguaFriaBomba] = useState('')
    const [tempSaidaAguaFriaBomba, setTempSaidaAguaFriaBomba] = useState('')
    const [volumeReservatorioM3, setVolumeReservatorioM3] = useState('')


    const [esquema, setEsquema] = useState()

    const [energiaAmbiente_id, setEnergiaAmbiente_id] = useState()
    const [resultadoAmbientes, setResultadoAmbientes] = useState()

    const [resultadoAquecimento, setResultadoAquecimento] = useState()
    

    const [resultadoFluidoRefrigerante, setResultadoFluidoRefrigerante] = useState()
    const [resultadoAquecimentoMarca, setResultadoAquecimentoMarca] = useState()

    const [listaAnos, setListaAnos] = useState()

    

    function carregaAnos() {

        var x_array = []

        for (var x = 1990; x <= 2030; x++) {
            
            x_array.push(x)

        }


        //console.log(x_array, 'aqui')
        setListaAnos(x_array.sort().reverse().map((ano) =>
        
            <option value={ano}>{ano}</option>
        
        ))
        

    }

    function carregaFluidoRefrigerante() {

        api.get('fluidoRefrigeranteListaTodos').then((result) => {

            //console.log(result.data)
            setResultadoFluidoRefrigerante(result.data.map((rs) =>

                <option value={rs.descricao}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function avisoCombustiveis() {


        if (tipo == 'Boiler' || tipo == 'Caldeira' || tipo == 'Aquecedor de Passagem')

        window.$.confirm({
            //icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'orange',
            title: 'Aviso',
            content: 'Reportar a Fonte Energética na aba <b>"Combustíveis"</b>',
            buttons: {
                Entendi: function () {

                    

                },
                
            },

        });

    }


    function apagaAquecimento() {


        if (energiaAquecimento_id) {

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaAquecimento/${energiaAquecimento_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow(false)
                            //consultaAquecimento()

                            window.$('#modalEnergiaAquecimento').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.sucess('Registro apagado com sucesso')
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }


    }


    function carregaAmbientes() {

        if (energia_id) {

            api.get(`energiaAmbienteLista/${energia_id}`).then((result) => {

                //console.log(result.data)
                setResultadoAmbientes(result.data.map((rs) =>

                    <option value={rs.energiaAmbiente_id} key={rs.energiaAmbiente_id}>{rs.identificacao}</option>
                
                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }


    function carregaMarcas() {

        api.get(`energiaAquecimentoMarcaListaTodos`).then((result) => {

            //console.log(result.data)
            setResultadoAquecimentoMarca(result.data.map((rs) =>
            
                <option key={rs.energiaAquecimentoMarca_id} value={rs.descricao}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    function carregaAquecimentoDet() {

        if (energiaAquecimento_id) {

            api.get(`energiaAquecimentoListaUm/${energiaAquecimento_id}`).then((result) => {

                //console.log(result.data, '!!')

                var data = result.data[0]

                setTipo(data.tipo)
                setTag(data.tag)
                setMarca(data.marca)
                setModelo(data.modelo)
                setAnoFabricacao(data.anoFabricacao == null ? '' : data.anoFabricacao.toString())
                setQuantidade(data.quantidade == null ? '' : data.quantidade.toString())
                
                setBanhoHigienizacao(data.banhoHigienizacao)
                setLimpezaEsterelizacao(data.limpezaEsterelizacao)
                setCoccao(data.coccao)
                setAquecimento(data.aquecimento)
                
                setEnergiaAmbiente_id(data.energiaAmbiente_id)
                setRotinaManutencao(data.rotinaManutencao)
                setEntradaOperacao(data.entradaOperacao)
                setSaidaOperacao(data.saidaOperacao)


                setFonteEnergetica(data.fonteEnergetica)
                setVolumeReservatorio(data.volumeReservatorio)
                setVazaoMediaAgua(data.vazaoMediaAgua)
                setTempoOperacaoDiario(data.tempoOperacaoDiario)
                setDiasOperacaoAnual(data.diasOperacaoAnual)
                setTempEntradaAgua(data.tempEntradaAgua)
                setTempProgramada(data.tempProgramada)

                setVolumeReservatorioM3(data.volumeReservatorioM3 == null ? '' : data.volumeReservatorioM3.toString())

            }).catch((err) => {

                console.log(err.response)

            })

        }

        

    }


    function salvaAquecimento() {


        if (tipo == '') {

            window.toastr.error('<b>Tipo</b> não pode ficar em branco!')
            return false

        }


        if (tag == '') {

            //window.toastr.error('<b>Tag</b> não pode ficar em branco!')
            //return false

        }


        if (marca == '') {

            window.toastr.error('<b>Marca</b> não pode ficar em branco!')
            return false

        }


        if (modelo == '') {

            //window.toastr.error('<b>Modelo</b> não pode ficar em branco!')
            //return false

        }


        if (anoFabricacao == '') {

            window.toastr.error('<b>Ano de Fabricação</b> não pode ficar em branco!')
            return false

        }


        if (quantidade == '') {

            window.toastr.error('<b>Quantidade</b> não pode ficar em branco!')
            return false

        } else {

            if (parseInt(quantidade) == 0) {

                window.toastr.error('<b>Quantidade</b> não pode ser igual a zero!')
                return false

            }

        }

        if (capacTermicaAquecimento != '') {

            if (capacTermicaAquecimento == '0') {

                window.toastr.error('<b>Capacidade térmica de aquecimento [kW]</b> não pode ser igual a zero!')
                return false

            }

        }

        if (copAquecimento != '') {

            if (copAquecimento == '0') {

                window.toastr.error('<b>COP de aquecimento [W/W]</b> não pode ser igual a zero!')
                return false

            }

        }

        if (copResfriamento != '') {

            if (copResfriamento == '0') {

                window.toastr.error('<b>COP de resfriamento [W/W]</b> não pode ser igual a zero!')
                return false

            }

        }

        if (banhoHigienizacao.toString() == '') {

            window.toastr.error('<b>Banho e Higienização</b> não pode ficar em branco!')
            return false

        }


        if (limpezaEsterelizacao.toString() == '') {

            window.toastr.error('<b>Limpeza/Esterilização</b> não pode ficar em branco!')
            return false

        }


        if (coccao.toString() == '') {

            window.toastr.error('<b>Cocção</b> não pode ficar em branco!')
            return false

        }

        
        if (aquecimento.toString() == '') {

            window.toastr.error('<b>Aquecimento para Climatização</b> não pode ficar em branco!')
            return false

        }

        if (rotinaManutencao == '') {

            window.toastr.error('<b>Rotina de Manutenção</b> não pode ficar em branco!')
            return false

        }


        if (esquema == 1) {

            if (fonteEnergetica == '') {

                window.toastr.error('<b>Fonte energética</b> não pode ficar em branco!')
                return false

            }

        }


        if (entradaOperacao != '') {


            if (entradaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Entrada em Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = entradaOperacao.split('/')
                var mesEntradaOperacao = x_array[0]

                

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Entrada em Operação</b>!')
                    return false
    
                }  else {

                    var dataEntradaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')

                }


                if (anoFabricacao != '' && x_array[1] != '') {

                    var anoFabricacao_r = parseInt(anoFabricacao)

                    var anoEntradaOperacao = parseInt(x_array[1])

                    if (anoEntradaOperacao < anoFabricacao_r) {


                        window.toastr.error('O <b>Ano de entrada em operação</b> não pode ser anterior que o <b>ano de fabricação</b>!')
                        return false


                    }

                }


            }
            

        }


        if (saidaOperacao != '') {


            if (saidaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Saída de Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = saidaOperacao.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Saída de Operação</b>!')
                    return false
    
                }


                if (anoEntradaOperacao != '' && x_array[1] != '' && x_array[0] != '' && mesEntradaOperacao != '') {
                
                    var anoSaidaOperacao = parseInt(x_array[1])
                    var mesSaidaOperacao = parseInt(x_array[0])

                    if (anoSaidaOperacao < anoEntradaOperacao) {

                        window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                        return false

                    } else {

                        var dataSaidaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')
                        //console.log(dataEntradaTemp, dataSaidaTemp)

                        //console.log('aqui..')

                        if (dataSaidaTemp < dataEntradaTemp) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }

                        /*
                        if (mesSaidaOperacao < parseInt(mesEntradaOperacao)) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }
                        */


                    }


                }


            }
            

        }


        if (esquema == 1) {


            if (fonteEnergetica == '') {

                window.toastr.error('<b>Fonte Energética</b> não pode ficar em branco!')
                return false

            }

        }


        if (volumeReservatorio != '') {

            if (volumeReservatorio == '0') {

                window.toastr.error('<b>Volume do reservatório</b> não pode ser igual a zero!')
                return false
            }

        }



        if (vazaoMediaAgua != '') {

            if (vazaoMediaAgua == '0') {

                window.toastr.error('<b>Vazão média de água</b> não pode ser igual a zero!')
                return false
            }

        }

        if (tempoOperacaoDiario != '') {

            if (tempoOperacaoDiario == '0') {

                window.toastr.error('<b>Tempo de operação diário</b> não pode ser igual a zero!')
                return false
            }

        }

        if (diasOperacaoAnual != '') {

            if (diasOperacaoAnual == '0') {

                window.toastr.error('<b>Dias de operação anual</b> não pode ser igual a zero!')
                return false
            
            } else {

                if (parseInt(diasOperacaoAnual) > 365) {

                    window.toastr.error('<b>Dias de operação anual</b> não pode maior que 365!')
                    return false

                }

            }

        }


        if (volumeReservatorioM3 != '') {

            if (volumeReservatorioM3 == '0') {

                window.toastr.error('<b>Volume do reservatório</b> não pode ser igual a zero!')
                return false
            }

        }



        var dataPost = {

            energia_id: energia_id,
            adesao_institucional_id: adesao_institucional_id,
            ano: ano,
            tipo: tipo,
            tag: tag,
            marca: marca,
            modelo: modelo,
            anoFabricacao: anoFabricacao,
            quantidade: quantidade,

            banhoHigienizacao: banhoHigienizacao,
            limpezaEsterelizacao: limpezaEsterelizacao,
            coccao: coccao,
            aquecimento: aquecimento,
            rotinaManutencao: rotinaManutencao,
            entradaOperacao: entradaOperacao,
            saidaOperacao: saidaOperacao,

            //ambiente: ambiente,
            energiaAmbiente_id: energiaAmbiente_id,

            fonteEnergetica: fonteEnergetica,
            volumeReservatorio: volumeReservatorio,
            vazaoMediaAgua: vazaoMediaAgua,
            tempoOperacaoDiario: tempoOperacaoDiario,
            diasOperacaoAnual: diasOperacaoAnual,
            tempEntradaAgua: tempEntradaAgua,
            tempSaidaAgua: tempSaidaAgua,
            tempProgramada: tempProgramada,


            fluidoRefrigerante: fluidoRefrigerante,
            capacTermicaAquecimento: capacTermicaAquecimento,
            copAquecimento: copAquecimento,
            tempEntradaAguaQuenteBomba: tempEntradaAguaQuenteBomba,
            tempSaidaAguaQuenteBomba: tempSaidaAguaQuenteBomba,

            capacTermicaResfriamento: capacTermicaResfriamento,
            copResfriamento: copResfriamento,

            tempEntradaAguaFriaBomba: tempEntradaAguaFriaBomba,
            tempSaidaAguaFriaBomba: tempSaidaAguaFriaBomba,
            volumeReservatorioM3: volumeReservatorioM3,

        }



        //console.log(dataPost, '!!')


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {



                    if (energiaAquecimento_id) {

                        //console.log('put')

                        api.put(`energiaAquecimento/${energiaAquecimento_id}`, dataPost).then(() => {
    
                            //setShow(false)
                            //consultaAquecimento()
                            //window.toastr.success('Registro salvo com sucesso!')
                            window.$('#modalEnergiaAquecimento').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.sucess('Registro apagado com sucesso')
                            avisoCombustiveis()
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })


                    } else {

                        api.post('energiaAquecimento', dataPost).then(() => {

                           
                            //setShow(false)
                            //consultaAquecimento()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalEnergiaAquecimento').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.sucess('Registro apagado com sucesso')
                            avisoCombustiveis()

    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });



    }


    function limpaDados() {

        

        setTipo('')
        setTag('')
        setMarca('')
        setModelo('')
        setAnoFabricacao('')
        setQuantidade('')

        setBanhoHigienizacao('')
        setLimpezaEsterelizacao('')
        setCoccao('')
        setAquecimento('')

        setRotinaManutencao('')
        setEntradaOperacao('')
        setSaidaOperacao('')

        //setAmbiente()
        setEnergiaAmbiente_id()
        setResultadoAmbientes()

        setFonteEnergetica('')
        setVolumeReservatorio('')
        setVazaoMediaAgua('')
        setTempoOperacaoDiario('')
        setDiasOperacaoAnual('')
        setTempEntradaAgua('')
        setTempSaidaAgua('')
        setTempProgramada('')


        setFluidoRefrigerante('')
        setCapacTermicaAquecimento('')
        setCopAquecimento('')
        setTempEntradaAguaQuenteBomba('')
        setTempSaidaAguaQuenteBomba('')

        setCapacTermicaResfriamento('')
        setCopResfriamento('')

        setTempEntradaAguaFriaBomba('')
        setTempSaidaAguaFriaBomba('')
        setVolumeReservatorioM3('')

        setEsquema()


    }




    useEffect(() => {

        limpaDados()
        carregaAnos()
        carregaAmbientes()
        carregaMarcas()
        carregaFluidoRefrigerante()
        carregaAquecimentoDet()

    }, [energiaAquecimento_id])



    useEffect(() => {

        //console.log(tipo)
        
        if (tipo != '') {

            switch (tipo) {

                case 'Boiler':
                case 'Caldeira':
                case 'Aquecedor de Passagem':              
                    setEsquema(1)
                    break



                case 'Bomba de Calor':
                    setEsquema(2)
                    break

                case 'Aquecedor Solar':
                    setEsquema(3)
                    break

            }

        }

    }, [tipo])


    const handleChange = (e) => {
        e.preventDefault();
    }



    return (

        <div>

                <div className="modal fade" id="modalEnergiaAquecimento" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Aquecimento</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">


                            <div className="col-md-12" >
                                    <b>Dados básicos</b>
                                    <br/><br/>
                            </div>
                                
                                
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Tipo *</label>
                                        <select class="form-control" value={tipo} onChange={event => setTipo(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Aquecedor de Passagem">Aquecedor de Passagem</option>
                                            <option value="Aquecedor Solar">Aquecedor Solar</option>
                                            <option value="Boiler">Boiler</option>
                                            <option value="Bomba de Calor">Bomba de Calor</option>
                                            <option value="Caldeira">Caldeira</option>
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >

                                        

                                        <label className="control-label">

                                                <span class="wrapper2">
                                                    Tag
                                                    <div class="tooltip">
                                                    insira uma descrição para identificar o equipamento.


                                                    </div>
                                                </span>

                                            </label>
                                    
                                    
                                        <input class="form-control" input="text" value={tag} onChange={event => setTag(event.target.value)} style={{ textTransform: 'uppercase'}}/>
                                            
                                    </div>
                                </div>

                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        
                                        <label className="control-label">Marca *</label>
                                        <select className="form-control" value={marca} onChange={event => setMarca(event.target.value)} >

                                            <option value="">[Selecione]</option>
                                            <option value="Não informado">Não informado</option>
                                            {resultadoAquecimentoMarca}

                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Modelo</label>
                                        <input class="form-control" input="text" value={modelo} onChange={event => setModelo(event.target.value)} style={{ textTransform: 'uppercase'}}/>
                                            
                                    </div>
                                </div>
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Ano de Fabricação *</label>
                                        <select class="form-control" value={anoFabricacao} onChange={event => setAnoFabricacao(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            {listaAnos}
                                            <option value="0">Não informado</option>
                                        </select>
                                        
                                            
                                    </div>
                                </div>
                               
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                    <br/>
                                        <label className="control-label">Quantidade *</label>
                                        <input class="form-control" input="text" value={quantidade} onChange={event => setQuantidade(event.target.value)}
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                        }} 
                                        />
                                            
                                    </div>
                                </div>


                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Aplicação</b>
                                    <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Banho e Higienização *</label>
                                            <select class="form-control" value={banhoHigienizacao} onChange={event => setBanhoHigienizacao(event.target.value)} >
                                                <option value="">[Selecione]</option>
                                                <option value={true}>Sim</option>
                                                <option value={false}>Não</option>
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Limpeza/Esterilização *</label>
                                            <select class="form-control" value={limpezaEsterelizacao} onChange={event => setLimpezaEsterelizacao(event.target.value)} >
                                                <option value="">[Selecione]</option>
                                                <option value={true}>Sim</option>
                                                <option value={false}>Não</option>
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Cocção *</label>
                                            <select class="form-control" value={coccao} onChange={event => setCoccao(event.target.value)} >
                                                <option value="">[Selecione]</option>
                                                <option value={true}>Sim</option>
                                                <option value={false}>Não</option>
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Aquecimento para Climatização *</label>
                                            <select class="form-control" value={aquecimento} onChange={event => setAquecimento(event.target.value)} >
                                                <option value="">[Selecione]</option>
                                                <option value={true}>Sim</option>
                                                <option value={false}>Não</option>
                                            </select>
                                                
                                        </div>
                                    </div>



                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Dados Operacionais</b>
                                    <br/><br/>
                                </div>


                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            
                                            <label className="control-label">Ambiente</label>
                                            <select class="form-control" value={energiaAmbiente_id} onChange={event => setEnergiaAmbiente_id(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                {resultadoAmbientes}
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-12" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Rotina de Manutenção *</label>
                                            <select class="form-control" value={rotinaManutencao} onChange={event => setRotinaManutencao(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="Períodica Semanal">Periódica Semanal</option>
                                                <option value="Períodica Mensal">Periódica Mensal</option>
                                                <option value="Períodica Anual">Periódica Anual</option>
                                                <option value="Corretiva (mediante falha)">Corretiva (mediante falha)</option>
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        <br/>

                                            <label className="control-label">

                                                <span class="wrapper2">
                                                    Entrada em Operação (Mês/Ano)
                                                    <div class="tooltip">
                                                    insira a data (mês e ano) quando o equipamento entrou em operação na unidade.


                                                    </div>
                                                </span>

                                            </label>

                                            <InputMask mask="99/9999" class="form-control" input="text" value={entradaOperacao} onChange={event => setEntradaOperacao(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        <br/>

                                            <label className="control-label">

                                                <span class="wrapper2">
                                                    Saída de operação (Mês/Ano)
                                                    <div class="tooltip">
                                                    insira a data (mês e ano) quando o equipamento saiu de operação na unidade.


                                                    </div>
                                                </span>

                                            </label>
                                        
                                            
                                            <InputMask mask="99/9999" class="form-control" input="text" value={saidaOperacao} onChange={event => setSaidaOperacao(event.target.value)} />
                                                
                                        </div>
                                    </div>

                                    


                                        <div className="col-md-12" >
                                            <br/><br/>
                                            <b>Outros Dados Técnicos e Operacionais</b>
                                            <br/><br/>
                                        </div>
                                            
                                            
                                        <div className="col-md-12" style={{ display: esquema == 1 ? 'table-row' : 'none' }} >
                                            <div class="form-group" >
                                            
                                                <label className="control-label">Fonte Energética *</label>
                                                <select class="form-control" value={fonteEnergetica} onChange={event => setFonteEnergetica(event.target.value)} >
                                                    <option value="">[Selecione]</option>
                                                    <option value="Energia Elétrica">Energia Elétrica</option>
                                                    <option value="Etanol Hidratado">Etanol Hidratado</option>
                                                    <option value="Gás Natural Seco">Gás Natural Seco</option>
                                                    <option value="Gasolina Comum (tipo C)">Gasolina Comum (tipo C)</option>
                                                    <option value="Gasolina Pura (tipo A)">Gasolina Pura (tipo A)</option>
                                                    <option value="Gás Liquefeito de Petróleo (GLP)">Gás Liquefeito de Petróleo (GLP)</option>
                                                    <option value="Óleo Combustível">Óleo Combustível</option>
                                                    <option value="Óleo de Xisto">Óleo de Xisto</option>
                                                    <option value="Óleo Diesel (Comercial)">Óleo Diesel (Comercial)</option>
                                                    <option value="Lenha (Comercial)">Lenha (Comercial)</option>
                                                    
                                                </select>
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" style={{ display: esquema == 1 ? 'table-row' : 'none' }} >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Volume do reservatório [l]</label>
                                                <input class="form-control" input="text" value={volumeReservatorio} onChange={event => setVolumeReservatorio(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" style={{ display: esquema == 1 ? 'table-row' : 'none' }} >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Vazão média de água [l/h]</label>
                                                <input class="form-control" input="text" value={vazaoMediaAgua} onChange={event => setVazaoMediaAgua(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" style={{ display: esquema == 1 ? 'table-row' : 'none' }} >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Tempo de operação diário [h]</label>
                                                <input class="form-control" input="text" value={tempoOperacaoDiario} onChange={event => setTempoOperacaoDiario(event.target.value)} 
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" style={{ display: esquema == 1 ? 'table-row' : 'none' }} >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Dias de operação anual [dia/ano]</label>
                                                <input class="form-control" input="text" value={diasOperacaoAnual} onChange={event => setDiasOperacaoAnual(event.target.value)} 
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" style={{ display: esquema == 1 ? 'table-row' : 'none' }} >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Temp. de entrada de água [<sup>o</sup>C]</label>
                                                <input class="form-control" input="text" value={tempEntradaAgua} onChange={event => setTempEntradaAgua(event.target.value)}  
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" style={{ display: esquema == 1 ? 'table-row' : 'none' }} >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Temp. programada [<sup>o</sup>C]</label>
                                                <input class="form-control" input="text" value={tempProgramada} onChange={event => setTempProgramada(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>


                                    
                                            
                                            
                                        <div className="col-md-12" style={{ display: esquema == 2 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                            
                                                <label className="control-label">Fluído Refrigerante</label>
                                                <select class="form-control" value={fluidoRefrigerante} onChange={event => setFluidoRefrigerante(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    {resultadoFluidoRefrigerante}
                                                </select>
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ display: esquema == 2 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Capacidade térmica de aquecimento [kW]</label>
                                                <input class="form-control" input="text" value={capacTermicaAquecimento} onChange={event => setCapacTermicaAquecimento(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        
                                        <div className="col-md-12" style={{ display: esquema == 2 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">COP de aquecimento [W/W]</label>
                                                <input class="form-control" input="text" value={copAquecimento} onChange={event => setCopAquecimento(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ display: esquema == 2 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Capacidade térmica de resfriamento [kW]</label>
                                                <input class="form-control" input="text" value={capacTermicaResfriamento} onChange={event => setCapacTermicaResfriamento(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ display: esquema == 2 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Temperatura de entrada da água quente na bomba de calor [<sup>o</sup>C]</label>
                                                <input class="form-control" input="text" value={tempEntradaAguaQuenteBomba} onChange={event => setTempEntradaAguaQuenteBomba(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ display: esquema == 2 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Temperatura de saída da água quente na bomba de calor [<sup>o</sup>C]</label>
                                                <input class="form-control" input="text" value={tempSaidaAguaQuenteBomba} onChange={event => setTempSaidaAguaQuenteBomba(event.target.value)} 
                                                
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ display: esquema == 2 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">COP de resfriamento [W/W]</label>
                                                <input class="form-control" input="text" value={copResfriamento} onChange={event => setCopResfriamento(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ display: esquema == 2 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Temperatura de entrada da água fria na bomba de calor [<sup>o</sup>C]</label>
                                                <input class="form-control" input="text" value={tempEntradaAguaFriaBomba} onChange={event => setTempEntradaAguaFriaBomba(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ display: esquema == 2 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Temperatura de saída da água fria na bomba de calor [<sup>o</sup>C]</label>
                                                <input class="form-control" input="text" value={tempSaidaAguaFriaBomba} onChange={event => setTempSaidaAguaFriaBomba(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>



                                        <div className="col-md-12" style={{ display: esquema == 3 ? 'table-row' : 'none' }}>
                                            <div class="form-group" >
                                            
                                                <label className="control-label">Volume do reservatório [m<sup>3</sup>]</label>
                                                <input class="form-control" input="text" value={volumeReservatorioM3} onChange={event => setVolumeReservatorioM3(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>


                        
                            </div>



                            </div>
                            <div className="modal-footer">

                                <button type="button" className="btn btn-danger" onClick={() => apagaAquecimento()} style={{ display: energiaAquecimento_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvaAquecimento()}>Salvar</button>

                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal